import { useQuery } from "@tanstack/react-query";

import { getSoilSightCmcRecommendation } from "services";

import { useIsAuthenticated } from "utils";

import { GET_SOIL_SIGHT_CMC_RECOMMENDATION } from "consts";

import { CmcScenarioRecommendation } from "models";

export const useGetSoilSightCmcRecommendation = (scenarioId: string | undefined, mainCropIds?: string[]) => {
  const isAuthenticated = useIsAuthenticated();

  return useQuery<CmcScenarioRecommendation[]>({
    queryKey: [GET_SOIL_SIGHT_CMC_RECOMMENDATION, scenarioId, mainCropIds],
    queryFn: async () => getSoilSightCmcRecommendation(scenarioId!),
    enabled: isAuthenticated && !!scenarioId,
    staleTime: 1000 * 60 * 5,
  });
};
